import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import FilltextSubcomponent from "../exercisesubcomponents/FilltextSubcomponent";
import React, {useState} from "react";
import ActionsComponent from "../components/ActionsComponent";
import globalVars from "../utils/globalVars";

export default function TableComponent(props) {
    const [showSolution, setShowSolution] = useState(false);

    function handleShowSolution() {
        setShowSolution(!showSolution)
    }

    const [showFeedback, setShowFeedback] = useState(false);

    function handleShowFeedback() {
        setShowFeedback(!showFeedback)
    }

    return (
        <div key={props.index}>
            <TableContainer component="div">
                <Table sx={{width: '80vw', border: '1px solid #ccc'}} aria-label="simple table">
                    {props.exercise?.columnheaders &&
                    <TableHead>
                        <TableRow key={0}>
                            {props.exercise.rows[0].map(
                                (c, ci) => {
                                    return (
                                        <TableCell key={"tableCellHead_" + ci} align="left" sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: '#eee',
                                            padding: '0.5em',
                                            // maxWidth: '100px',
                                            width: (100 / (props.exercise.rows[0].length + 0)) + "%",
                                        }}>
                                            {c}
                                        </TableCell>
                                    )
                                }
                            )}
                        </TableRow>

                    </TableHead>
                    }
                    <TableBody>
                        {
                            props.exercise.rows.slice(props.exercise?.columnheaders ? 1 : 0).map(
                                (r, ri) => {
                                    return (
                                        <TableRow key={ri} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                                            {r.map(
                                                (c, ci) => {
                                                    return (
                                                        <TableCell key={"tableCellBody_" + ci} align="left"
                                                                   sx={{
                                                                       padding: '0.5em',
                                                                       maxWidth: '40px',
                                                                       fontWeight: (ci === 0 && props.exercise.rowheaders) ? 'bold' : 'inherit',
                                                                       backgroundColor: (ci === 0 && props.exercise.rowheaders) ? '#eee' : 'transparent',

                                                                   }}>
                                                            <FilltextSubcomponent
                                                                showSolution={showSolution}
                                                                showFeedback={showFeedback}
                                                                filltext={c}/>
                                                        </TableCell>
                                                    )
                                                }
                                            )}
                                        </TableRow>
                                    )
                                }
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <ActionsComponent
                onToggleShowSolution={handleShowSolution}
                onToggleShowFeedback={handleShowFeedback}
                {...props}
            />
            {showSolution &&
            <p><span style={{backgroundColor: globalVars.solutionMode.on, color: '#333'}}>Gehen Sie mit dem Mauszeiger über das Feld, um die richtige Antwort anzuzeigen</span>
            </p>}
        </div>
    );
}
